import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { useBetreuer, useBetreuerByKz } from 'api/betreuer';
import { MenuPlacement } from 'react-select/src/types';

interface BetreuerByKzProps {
    label: string;
    disabled: boolean;
    value: string;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    onChange: (newValue: string) => void;
}

export const BetreuerByKz: React.FC<BetreuerByKzProps> = ({
    label,
    value,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    onChange,
}) => {
    const betreuer = useBetreuer();
    const betreuerByKz = useBetreuerByKz();

    const options = React.useMemo(() => {
        const o = betreuer
            .filter((b) => b.aktiv && b.name)
            .map((b) => ({
                value: b.kz,
                label: b.name,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [betreuer, allowEmpty]);

    return (
        <>
            <Label>{label}</Label>
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: betreuerByKz[value]?.name || value,
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '');
                }}
            />
        </>
    );
};
